import { SupabaseRepositoryNotImplementedError } from '../supabase-api.js';
/**
 * Nur die Lesepfade, die die Account-UI braucht. Alles andere bleibt
 * ausdruecklich offen und meldet sich als "noch nicht implementiert", statt
 * still etwas Falsches zu liefern.
 *
 * RLS sorgt dafuer, dass ein Nutzer ohnehin nur die eigene Zeile sieht – die
 * userId hier ist keine Zugriffskontrolle, sondern nur der Filter.
 */
export class SupabaseUserRepository {
    client;
    constructor(client) {
        this.client = client;
    }
    async getProfile(userId) {
        const { data, error } = await this.client
            .from('profile')
            .select('id, display_name, avatar_url, is_admin, is_anonymous, theme, locale, created_at')
            .eq('id', userId)
            .maybeSingle();
        if (error)
            throw new Error(`Profil laden fehlgeschlagen: ${error.message}`);
        if (!data)
            return null;
        return {
            id: data.id,
            displayName: data.display_name,
            avatarUrl: data.avatar_url,
            isAdmin: data.is_admin,
            isAnonymous: data.is_anonymous,
            theme: data.theme,
            locale: data.locale,
            createdAt: data.created_at,
        };
    }
    async getPsnAccount(userId) {
        const { data, error } = await this.client
            .from('psn_account')
            .select('id, user_id, psn_account_id, online_id, verification_state, verification_code, verification_code_expires_at, verified_at, last_synced_at')
            .eq('user_id', userId)
            .maybeSingle();
        if (error)
            throw new Error(`PSN-Konto laden fehlgeschlagen: ${error.message}`);
        if (!data)
            return null;
        return {
            id: data.id,
            userId: data.user_id,
            psnAccountId: data.psn_account_id ?? '',
            onlineId: data.online_id,
            verificationState: data.verification_state,
            verificationCode: data.verification_code,
            verificationCodeExpiresAt: data.verification_code_expires_at,
            verifiedAt: data.verified_at,
            lastSyncedAt: data.last_synced_at,
        };
    }
    updateProfile() {
        return Promise.reject(new SupabaseRepositoryNotImplementedError('users.updateProfile'));
    }
    listRuns() {
        return Promise.reject(new SupabaseRepositoryNotImplementedError('users.listRuns'));
    }
    getRun() {
        return Promise.reject(new SupabaseRepositoryNotImplementedError('users.getRun'));
    }
    startRun() {
        return Promise.reject(new SupabaseRepositoryNotImplementedError('users.startRun'));
    }
    listNotes() {
        return Promise.reject(new SupabaseRepositoryNotImplementedError('users.listNotes'));
    }
    upsertNote() {
        return Promise.reject(new SupabaseRepositoryNotImplementedError('users.upsertNote'));
    }
    deleteNote() {
        return Promise.reject(new SupabaseRepositoryNotImplementedError('users.deleteNote'));
    }
}
//# sourceMappingURL=user-repository.js.map